// @ai-generated 2026-08-03T12:11:32+00:00 by malte.ulfers@tngtech.com using Claude Opus 4.7
import { useHasPermission } from '@Contexts/appContext';
import { useHasSystemAccess } from '@Contexts/session/useHasSystemAccess';
import { Table, useServerListApi } from '@synqo/frontend-component-library';
import type { ApiValidationRuleset } from '@Model';

interface RulesetListProps {
    apiPath: string;
    name: string;
    createPermission: string;
}

export function RulesetList({ apiPath, name, createPermission }: RulesetListProps) {
    const module = useServerListApi<ApiValidationRuleset>({ path: apiPath });

    const hasPermission = useHasPermission();
    const hasSystemAccess = useHasSystemAccess();

    return (
        <Table<ApiValidationRuleset>
            name={name}
            columns={[
                { name: 'key', label: 'Schlüssel' },
                { name: 'title', label: 'Titel' },
                { name: 'description', label: 'Beschreibung' },
            ]}
            loader={module.loadPage}
            canCreate={hasSystemAccess && hasPermission(createPermission)}
            useOnClickNavigation
            fullSize
        />
    );
}
